import S from '../locales/app.json'
import { toggleLang, tr, useLang } from '../lib/i18n'

// R537: the switch names the language it switches to (the driver app's toggle: the English
// screen shows the Arabic word, the Arabic screen shows "English"). Its accessible name says
// what it is and keeps the visible word in it. 44 px both ways, a visible focus ring.
const TONE = {
  onNavy:
    'min-h-tap min-w-[44px] inline-flex items-center justify-center rounded-xl border border-white/40 px-3 text-sm font-semibold text-white hover:bg-white/10 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white',
  onLight:
    'min-h-tap min-w-[44px] inline-flex items-center justify-center rounded-lg bg-fleet-700 px-4 text-sm font-semibold text-white hover:bg-fleet-600 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-navy focus-visible:ring-offset-2',
} as const

export function LangToggle({ id, tone }: { id: string; tone: keyof typeof TONE }) {
  const lang = useLang()
  const word = tr(S.langToggle, lang)
  return (
    <button
      id={id}
      type="button"
      data-lang-toggle=""
      onClick={toggleLang}
      aria-label={`${tr(S.langToggleLabel, lang)}: ${word}`}
      className={TONE[tone]}
    >
      <span lang={lang === 'ar' ? 'en' : 'ar'}>{word}</span>
    </button>
  )
}
